import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Pane } from 'tweakpane'

import vertex from './shaders/vertex.glsl'
import fragment from './shaders/fragment.glsl'


/**
 * Functions
 */

/**
 * Base
 */
// Debug$
const pane = new Pane()
const debug = {}
debug.timeSpeed = 0.5

pane.addBinding(debug, 'timeSpeed', { min: 0, max: 10, step: 0.1 })


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
/**
 * Plane
 */
// Geometry

// const geometry = sizes.width < sizes.height ? new THREE.PlaneGeometry(sizes.width, sizes.width) : new THREE.PlaneGeometry(sizes.height, sizes.height)
const geometry = new THREE.PlaneGeometry(1, 1)
const material = new THREE.ShaderMaterial({
    side: THREE.DoubleSide,
    vertexShader: vertex,
    fragmentShader: fragment,
    uniforms: {
        u_time: new THREE.Uniform(0),
        u_smooth: new THREE.Uniform(70),
        u_size: new THREE.Uniform(150),
        u_resolution: new THREE.Uniform(sizes.width > sizes.height ? new THREE.Vector2(sizes.height, sizes.height) : new THREE.Vector2(sizes.width, sizes.width)),
        u_pixelRatio: new THREE.Uniform(window.devicePixelRatio),

    }
})
pane.addBinding(material.uniforms.u_smooth, 'value', { min: 0, max: 100, step: 0.001, label: 'shapes smoothing' })
pane.addBinding(material.uniforms.u_size, 'value', { min: 0, max: 500, step: 0.001, label: 'shapes size' })

const mesh = new THREE.Mesh(geometry, material)
if (sizes.width < sizes.height) {
    mesh.scale.set(sizes.width, sizes.width, 1)
}
else {
    mesh.scale.set(sizes.height, sizes.height, 1)
}
scene.add(mesh)

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    if (sizes.width < sizes.height) {
        mesh.scale.set(sizes.width, sizes.width, 1)
    }
    else {
        mesh.scale.set(sizes.height, sizes.height, 1)
    }


    // Update camera
    camera.left = -sizes.width / 2
    camera.right = sizes.width / 2
    camera.top = -sizes.height / 2
    camera.bottom = sizes.height / 2
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.OrthographicCamera(-sizes.width / 2, sizes.width / 2, -sizes.height / 2, sizes.height / 2, -1000, 1000)
camera.position.set(0, 0, 1)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    material.uniforms.u_time.value = elapsedTime * debug.timeSpeed

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()